import React from 'react';
import TagColorRadioButton, { defaultTagColors } from './TagColorRadioButton';

interface TagColorPickerProps {
  selectedTagColor?: string;
  onColorSelect?: (color: string) => void;
}

export default function TagColorPicker({
  selectedTagColor = defaultTagColors.turquoise,
  onColorSelect
}: TagColorPickerProps){
  return (
    <div className="flex">
      <label className="font-semibold pr-2">Tag colour</label>
        {Object.keys(defaultTagColors).map((key) => {
          const tagColor = defaultTagColors[key];
          return (
            <TagColorRadioButton
              key={key}
              tagColor={tagColor}
              tagColorName={key}
              containerClassName="px-1"
              buttonClassName="w-4 h-4"
              name="tag-color-picker"
              checked={selectedTagColor === tagColor}
              onClick={() => onColorSelect?.(tagColor)}
            />
          );
        })}
    </div>
  );
}